<ng-container [ngSwitch]="useProviderLocation">
    <mat-form-field class="mat-field-width"
            *ngSwitchCase="false">
        <input matInput [formControl]="control"
               [placeholder]="config.label" />
        <mat-error>
            <span>Location is required</span>
        </mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width"
            *ngSwitchCase="true">
        <mat-select [formControl]="control"
                [placeholder]="config.label"
                [errorStateMatcher]="errorMatcher">
            <mat-option *ngFor="let l of trackingList" [value]="l.key">
                {{l.value}}
            </mat-option>
        </mat-select>
        <mat-error>
            <span>Location is required</span>
        </mat-error>
    </mat-form-field>
</ng-container>